import { ArticlesList } from "components/blog/articles-list";
import { Button } from "components/ui/button";
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from "components/ui/card";
import { ArrowRight } from "lucide-react";
import { useHistory } from "react-router-dom";
import * as Routes from "routes";

export const WhatsNewCard = () => {
  const history = useHistory();

  const handleArticleClick = (identifier: string) => {
    history.push(`/whats-new/${identifier}`);
  };

  return (
    <Card className="flex h-full flex-col">
      <CardHeader className="gap-0">
        <CardTitle>What&apos;s New</CardTitle>
        <CardAction>
          <Button
            className="hover:cursor-pointer"
            variant="ghost"
            size="sm"
            onClick={() => history.push(Routes.whatsNew)}
          >
            View all updates
            <ArrowRight className="size-4 ml-2" />
          </Button>
        </CardAction>
      </CardHeader>
      <CardContent className="flex min-h-0 flex-1">
        <ArticlesList limit={4} fill onArticleClick={handleArticleClick} />
      </CardContent>
    </Card>
  );
};
